<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="650"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                {{ form.id === '' ? 'Tambah' : 'Ubah' }}
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <!-- <v-row>
                    <v-col
                      v-for="(item, index) in form.config_sallary"
                      :key="index"
                      cols="12"
                      md="6"
                      style="position: relative;">
                    </v-col>
                  </v-row> -->

                  <div
                    v-for="(item, index) in form.config_sallary"
                    :key="index"
                    :class="index > 0 ? 'mt-6' : ''">
                    <div
                      class="body-1 black--text text-capitalize d-flex align-center mb-2"
                      style="font-weight: 500;">
                      <v-icon small color="black">mdi-transfer-right</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ item.type }}
                      </span>
                    </div>

                    <div
                      v-for="(item_sub, index_sub) in item.child"
                      :key="index_sub">
                      <v-row
                        align="center">
                        <v-col
                          cols="12"
                          md="5">
                          <div
                            class="d-flex align-center">
                            <v-icon>mdi-circle-small</v-icon>

                            <span
                              class="body-2">
                              {{ item_sub.label }}
                            </span>
                          </div>
                        </v-col>

                        <v-col
                          cols="12"
                          md="7"
                          class="d-flex align-center">
                          <div
                            class="mr-2">
                            Rp
                          </div>

                          <ValidationProvider
                            :name="item_sub.label" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <v-currency-field
                              filled
                              rounded
                              dense

                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              :min="0"

                              @focus="$event.target.select()"
                              v-on:keydown.tab="formula().values(index)"
                              @keyup="formula().values(index)"
                              @blur="formula().values(index)"
                              @change="formula().values(index)"

                              :color="set_color"
                              placeholder="Rp 0"

                              hide-details

                              v-model="item_sub.nominal"
                              :success="item_sub.nominal !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="item_sub.nominal !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </div>

                    <v-card
                      flat
                      color="#f0f0f0"
                      class="mt-2"
                      style="border-radius: 10px;">
                      <v-card-text
                        class="py-0">
                        <v-row
                          align="center">
                          <v-col
                            cols="12"
                            md="5">
                            <div
                              class="body-1 black--text text-capitalize"
                              style="font-weight: 500;">
                              Total {{ item.type }}
                            </div>
                          </v-col>

                          <v-col
                            cols="12"
                            md="7">
                            <div
                              class="title black--text font-weight-bold">
                              {{ item.nominal | price }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </div>

                  <v-card v-if="form.config_sallary.length > 0"
                    flat
                    color="#f0f0f0"
                    class="mt-6"
                    style="border-radius: 10px;">
                    <v-card-text
                      class="py-0">
                      <v-row
                        align="center">
                        <v-col
                          cols="12"
                          md="5">
                          <div
                            class="body-1 black--text text-capitalize"
                            style="font-weight: 500;">
                            Total Take Home Pay
                          </div>
                        </v-col>

                        <v-col
                          cols="12"
                          md="7">
                          <div
                            class="title black--text font-weight-bold">
                            {{ total_sallary() | price }}
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>

                  <div
                    class="mt-6 mb-3">
                    <ValidationProvider 
                      name="Deskripsi" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <!-- <span class="red--text">*</span> -->
                        Deskripsi
                      </div>

                      <v-textarea
                        v-on:keyup.enter="save()"
                        
                        filled
                        rounded
                        dense
                        rows="5"

                        :color="set_color"
                        placeholder="Contoh. Tuliskan deskripsi disini . . ."

                        hide-details

                        v-model="form.note"
                        :success="form.note !== '' && valid"
                        :error-messages="errors"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              {{ errors[0] }}
                            </v-tooltip>
                          </div>
                          
                          <div v-if="form.note !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-textarea>
                    </ValidationProvider>
                  </div>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.detail"
          @keydown.esc="dialog.detail = false"
          :fullscreen="dialog.fullscreen"
          width="650"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                {{ selected.name }}
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.detail = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 mt-4 mb-6">
              <div
                v-for="(item, index) in detail"
                :key="index"
                :class="index > 0 ? 'mt-6' : ''">
                <div
                  class="body-1 black--text text-capitalize d-flex align-center mb-2"
                  style="font-weight: 500;">
                  <v-icon small color="black">mdi-transfer-right</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ item.type }}
                  </span>
                </div>

                <div
                  v-for="(item_sub, index_sub) in item.child"
                  :key="index_sub">
                  <v-row
                    align="center">
                    <v-col
                      cols="12"
                      md="5">
                      <div
                        class="d-flex align-center">
                        <v-icon>mdi-circle-small</v-icon>

                        <span
                          class="body-2">
                          {{ item_sub.label }}
                        </span>
                      </div>
                    </v-col>

                    <v-col
                      cols="12"
                      md="7"
                      class="text-right">
                      {{ item_sub.nominal | price }}
                    </v-col>
                  </v-row>
                </div>

                <v-card
                  flat
                  color="#f0f0f0"
                  class="mt-2"
                  style="border-radius: 10px;">
                  <v-card-text
                    class="py-0">
                    <v-row
                      align="center">
                      <v-col
                        cols="12"
                        md="5">
                        <div
                          class="body-1 black--text text-capitalize"
                          style="font-weight: 500;">
                          Total {{ item.type }}
                        </div>
                      </v-col>

                      <v-col
                        cols="12"
                        md="7">
                        <div
                          class="body-1 black--text font-weight-bold text-right">
                          {{ item.child.reduce((a, item) => a + Number(item.nominal), 0) | price }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </div>

              <v-card v-if="detail.length > 0"
                flat
                color="#f0f0f0"
                class="mt-6"
                style="border-radius: 10px;">
                <v-card-text
                  class="py-0">
                  <v-row
                    align="center">
                    <v-col
                      cols="12"
                      md="5">
                      <div
                        class="body-1 black--text text-capitalize"
                        style="font-weight: 500;">
                        Total Take Home Pay
                      </div>
                    </v-col>

                    <v-col
                      cols="12"
                      md="7">
                      <div
                        class="body-1 black--text font-weight-bold text-right">
                        {{ total_sallary() | price }}
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="dialog.detail = false"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Reset Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin mereset data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Reset
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <!-- <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="humax"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Konfigurasi Gaji
                    </span>
                  </div>

                  <v-spacer />

                  <div>
                    
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row> -->

          <v-row
            align="center"
            justify="end"
            class="pa-4 py-0 pr-1">
            <v-col
              cols="12"
              md="4"
              class="d-flex align-center">
              <v-text-field
                @click:clear="search = ''; fetch();"
                v-on:keyup.enter="fetch()"

                filled
                rounded
                dense
                single-line

                hide-details
                :color="set_color"
                placeholder="Cari data yang Anda butuhkan . . ."
                append-icon="mdi-magnify"
                clearable

                v-model="search"
                style="border-radius: 10px;">
              </v-text-field>

              <!-- FREEZE COLUMN -->
              <!-- <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="0"
                      outlined
                      dark
                      min-width="36"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 10px;"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog.freeze = true">
                      <v-icon size="18">mdi-table-split-cell</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Freeze
                  </span>
                </v-tooltip>
              </div> -->

              <!-- HIDE COLUMN -->
              <!-- <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="0"
                      outlined
                      dark
                      min-width="36"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 10px;"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog.hide = true">
                      <v-icon size="18">mdi-eye-off-outline</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Hide
                  </span>
                </v-tooltip>
              </div> -->
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-data-table
                  v-model="selected.row"
                  ref="table-grid"
                  class="table-grid"
                  :height="`calc(100vh - ${pagination.total_data > 0 ? '380px' : '308px'})`"
                  :show-select="checkbox"
                  :single-select="true"
                  :loading="process.load"
                  loading-text="Sedang memuat data . . ."
                  loader-height="5"
                  no-results-text="Belum ada data"
                  :options.sync="options"
                  :headers="configHeaders"
                  :items="list"
                  :items-per-page="100"
                  item-key="id"
                  @click:row="rowClick"
                  @toggle-select-all="handleToggleAll($event)"
                  @dblclick:row="doubleClick"
                  hide-default-footer>
                  <template
                    v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                    v-slot:[`item.${header.value}`]="{ value, index }">
                    <div
                      v-bind:key="header.value">
                      <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'">
                        {{ rowFormat(header.format, value) }} 
                      </div>

                      <div v-if="header.format === 'link'"
                        class="cursor-pointer">
                        
                      </div>
        
                      <div v-if="header.format === 'regex'">
                        <span
                          class="two-line">
                          {{ rowFormat(header.format, value) }}
                        </span>
                      </div>
        
                      <div v-if="header.format === 'image'"
                        class="ma-4">
                        <v-avatar
                          size="60"
                          tile
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <v-img 
                            contain
                            width="100%"
                            height="100%"
                            alt="humax" 
                            :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                            class="ma-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-avatar>
                      </div>

                      <div v-if="header.format === 'image_potrait'"
                        class="ma-4">
                        <v-img 
                          contain
                          width="100"
                          height="125"
                          alt="humax" 
                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                          class="ma-auto"
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <div v-if="header.format === 'image_landscape'"
                        class="ma-4">
                        <v-img 
                          contain
                          width="200"
                          height="125"
                          alt="humax" 
                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                          class="ma-auto"
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <div v-if="header.format === 'action'">
                        <v-tooltip 
                          top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="dialog.form = true; reset(index, 'add');"

                              v-bind="attrs"
                              v-on="on"

                              :disabled="list[index].is_set_sallary_bool"

                              min-width="28"
                              small
                              rounded
                              color="green"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-plus-circle-multiple</v-icon>
                            </v-btn>
                          </template>

                          <span>Tambah</span>
                        </v-tooltip>

                        <v-tooltip 
                          top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="dialog.form = true; reset(index, 'edit');"

                              v-bind="attrs"
                              v-on="on"

                              :disabled="!list[index].is_set_sallary_bool"

                              min-width="28"
                              small
                              rounded
                              :color="set_color"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-square-edit-outline</v-icon>
                            </v-btn>
                          </template>

                          <span>Ubah</span>
                        </v-tooltip>

                        <v-menu
                          right
                          offset-y
                          style="box-shadow: none !important;">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"

                              min-width="28"
                              small
                              rounded
                              color="#37474F"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>

                          <v-list
                            dense
                            color="#808080"
                            class="py-1 my-2"
                            style="border-radius: 10px !important;">
                            <v-list-item
                              class="px-2">
                              <v-tooltip 
                                right>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    @click="toDelete(value)"

                                    v-bind="attrs"
                                    v-on="on"

                                    :disabled="!list[index].is_set_sallary_bool"
                                    min-width="28"
                                    small
                                    rounded
                                    color="orange"
                                    elevation="0"
                                    class="white--text text-capitalize px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon small>mdi-database-refresh-outline</v-icon>
                                  </v-btn>
                                </template>

                                <span>Reset</span>
                              </v-tooltip>
                            </v-list-item>

                            <v-list-item
                              class="px-2">
                              <v-tooltip 
                                right>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    @click="fetchDetail(value, 'detail'); selected.name = list[index].name"

                                    v-bind="attrs"
                                    v-on="on"

                                    :disabled="!list[index].is_set_sallary_bool"
                                    min-width="28"
                                    small
                                    rounded
                                    color="blue"
                                    elevation="0"
                                    class="white--text text-capitalize px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon small>mdi-subtitles-outline</v-icon>
                                  </v-btn>
                                </template>

                                <span>Detail</span>
                              </v-tooltip>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>

                      <div v-if="header.format === 'bool'"
                        class="d-flex align-center justify-center">
                        
                      </div>

                      <div v-if="header.format === 'status'"
                        class="d-flex justify-center">
                        <v-chip
                          small
                          rounded
                          :color="value ? 'green' : 'red'"
                          elevation="0"
                          class="text-capitalize white--text mx-1 d-flex justify-center"
                          style="font-weight: 600; width: 100px;">
                          {{ value ? 'Sudah Diset' : 'Belum Diset' }}
                        </v-chip>
                      </div>
                    </div>
                  </template>

                  <template v-slot:[`item.index`]="{ index }">
                    {{ lastIndex + index }}
                  </template>

                  <v-progress-linear 
                    v-show="process.load" 
                    slot="progress" 
                    color="white" 
                    indeterminate>
                  </v-progress-linear>
                </v-data-table>

                <pagination v-if="pagination.total_data > 0"
                  @changePage="fetch($event)" 
                  @reloadPage="fetch($event)" 
                  :model="pagination"/>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          form: false,
          detail: false,
          delete: false
        },
        
        search: '',

        selected: {
          row: [],
          freeze: [],
          delete: [],

          name: ''
        },

        detail: [],

        options: {},
        headers: [],
        list: [],
        pagination: {},

        lastIndex: 0,
        limit: 20,

        form: {
          user_id: '',
          config_sallary: [],
          note: ''
        },

        process: {
          load: false,

          form: false,

          delete: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          
          this.fetch(pagination)
        },
        deep: true
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      months () {
        let numb = new Date().getMonth() + 1
        
        this.filter.month = numb < 10 ? `0${numb}`.toString() : numb.toString()

        return [
          {
            text: 'Januari',
            value: '01'
          },
          {
            text: 'Februari',
            value: '02'
          },
          {
            text: 'Maret',
            value: '03'
          },
          {
            text: 'April',
            value: '04'
          },
          {
            text: 'Mei',
            value: '05'
          },
          {
            text: 'Juni',
            value: '06'
          },
          {
            text: 'Juli',
            value: '07'
          },
          {
            text: 'Agustus',
            value: '08'
          },
          {
            text: 'September',
            value: '09'
          },
          {
            text: 'Oktober',
            value: '10'
          },
          {
            text: 'November',
            value: '11'
          },
          {
            text: 'Desember',
            value: '12'
          }
        ]
      },
      years () {
        let max = new Date().getFullYear(), min = max - 10, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    mounted () {
      
    },
    methods: {
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = parseInt(value) + '%'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },

      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search
        }

        this.selected.row = []

        await get(`admin/user_config_sallary/data_user`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.headers = [
              {
                text: 'Aksi',
                width: '140px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'center',
                format: 'action'
              },
              {
                text: 'Konfigurasi Gaji',
                width: '150px',
                value: 'is_set_sallary_bool',
                freeze: false,
                hide: false,
                align: 'center',
                format: 'status'
              },
              {
                text: 'Nomor Induk Pegawai',
                width: '200px',
                value: 'code',
                freeze: false,
                hide: false
              },
              {
                text: 'Nama Lengkap',
                width: '300px',
                value: 'name',
                freeze: false,
                hide: false
              },
              {
                text: 'Total Take Home Pay',
                width: '200px',
                value: 'total_sallary',
                freeze: false,
                hide: false,
                align: 'end',
                format: 'number'
              },
              // {
              //   text: 'Unit / Divisi',
              //   width: '300px',
              //   value: 'unit_name',
              //   freeze: false,
              //   hide: false
              // },
              // {
              //   text: 'Jabatan',
              //   width: '200px',
              //   value: 'position',
              //   freeze: false,
              //   hide: false
              // },
              // {
              //   text: 'Level Jabatan',
              //   width: '200px',
              //   value: 'role',
              //   freeze: false,
              //   hide: false
              // }
            ]

            this.list = res.results.data
            this.pagination = res.results.pagination

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },

      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      async fetchDetail (id, type) {
        let params = {
          user_id: id
        }

        await get(`admin/user_config_sallary/data`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            let data = res.results.data

            let arrs = []
            
            data.forEach(obj => {
              if (!arrs.find(item => item.type === obj.type)) {
                arrs.push({
                  id: obj.id,
                  config_sallary_id: obj.config_sallary_id,
                  company_id: obj.company_id,
                  label: obj.label,
                  is_active_bool: obj.is_active_bool,
                  category: obj.category,
                  type: obj.type,
                  order_by: obj.order_by,
                  nominal: obj.nominal,
                  child: []
                })
              }

              arrs.forEach(obj_sub => {
                if (obj_sub.type === obj.type) {
                  obj_sub.child.push({
                    id: obj.id,
                    config_sallary_id: obj.config_sallary_id,
                    company_id: obj.company_id,
                    label: obj.label,
                    is_active_bool: obj.is_active_bool,
                    category: obj.category,
                    type: obj.type,
                    order_by: obj.order_by,
                    nominal: obj.nominal
                  })
                } 
              })
            })

            if (type === 'detail') {
              this.detail = arrs

              this.dialog.detail = true
            } else {
              this.form.config_sallary = arrs
            }
          }
        })
      },

      async fetchMaster () {
        let params = {
          limit: 100000,

          is_active_bool: true
        }

        await get(`admin/config_sallary/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            let data = res.results.data

            let arrs = []
            
            data.forEach(obj => {
              if (!arrs.find(item => item.type === obj.type)) {
                arrs.push({
                  id: obj.id,
                  company_id: obj.company_id,
                  label: obj.label,
                  is_active_bool: obj.is_active_bool,
                  category: obj.category,
                  type: obj.type,
                  order_by: obj.order_by,
                  nominal: 0,
                  child: []
                })
              }

              arrs.forEach(obj_sub => {
                if (obj_sub.type === obj.type) {
                  obj_sub.child.push({
                    id: obj.id,
                    company_id: obj.company_id,
                    label: obj.label,
                    is_active_bool: obj.is_active_bool,
                    category: obj.category,
                    type: obj.type,
                    order_by: obj.order_by,
                    nominal: 0
                  })
                } 
              })
            })

            this.form.config_sallary = arrs
          }
        })
      },

      reset (index, type) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          user_id: index !== undefined ? this.list[index].id : '',
          config_sallary: index !== undefined ? this.list[index].config_sallary : [],
          note: ''
        }

        this.process.form = false

        this.message.error = ''

        if (this.dialog.form) {
          if (type === 'add') {
            this.fetchMaster()
          } else {
            this.fetchDetail(this.list[index].id, 'form')
          }
        }
      },

      formula () {
        let t = this

        return {
          values (index) {
            let total = t.form.config_sallary[index].child.reduce((a, item) => a + Number(item.nominal), 0)

            t.form.config_sallary[index].nominal = Number(total)
          }
        }
      },

      total_sallary () {
        let total = 0, total_income = 0, total_deduction = 0

        if (this.dialog.form && this.form.config_sallary.length > 0) {
          this.form.config_sallary.forEach(obj => {
            if (obj.type === 'income') {
              total_income += obj.child.reduce((a, item) => a + Number(item.nominal), 0)
            } 
            
            if (obj.type === 'deduction') {
              total_deduction += obj.child.reduce((a, item) => a + Number(item.nominal), 0)
            }
          })

          total = total_income - total_deduction
        }

        if (this.dialog.detail && this.detail.length > 0) {
          this.detail.forEach(obj => {
            if (obj.type === 'income') {
              total_income += obj.child.reduce((a, item) => a + Number(item.nominal), 0)
            } 
            
            if (obj.type === 'deduction') {
              total_deduction += obj.child.reduce((a, item) => a + Number(item.nominal), 0)
            }
          })

          total = total_income - total_deduction
        }

        return total
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let data = this.form.config_sallary, data_form = []

          data.forEach(obj => {
            obj.child.forEach(obj_sub =>  {
              data_form.push(obj_sub)
            })
          })

          // SAVE TO REST API
          await post(`admin/user_config_sallary/update`, {
            data: {
              user_id: this.form.user_id,
              config_sallary: data_form,
              note: this.form.note
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.reset()

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`admin/user_config_sallary/delete`, {
          data: {
            user_id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>